import UserGroups from '../pages/UserGroups';

const UserGroupsRoutes = [
  {
    breadcrumb: [{ path: '/user-groups', breadcrumbName: 'User Groups' }],
    Component: UserGroups,
  },
];

export default UserGroupsRoutes;
